import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#0d4ea0";
function LSK({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M10.687 19.094c-.01.01-.032.02-.042.031H9.48c-.021 0-.032-.01-.042-.021l-3.431-3.876a.07.07 0 010-.062L10.28 7.79c.021-.031.073-.031.094 0l1.195 2.068c.01.01.01.031 0 .053l-2.89 4.983c-.01.02 0 .041.01.063l1.726 1.943a.1.1 0 00.042.02h2.038c.052 0 .073.053.041.084zm1.267-14.187c.022-.043.074-.043.084 0l5.958 10.237c.01.022 0 .043-.01.063l-3.431 3.876a.1.1 0 01-.042.021h-2.787c-.052 0-.072-.052-.04-.083l1.86-2.11 1.747-1.965c.02-.021.02-.042.01-.062l-3.307-5.705-1.247-2.152c-.01-.01-.01-.031 0-.053z" /></Svg>;
}
LSK.DefaultColor = DefaultColor;
export default LSK;